import React from 'react';
import styled from 'styled-components';
import Location from './Location';
import Events from './Events';
import Registry from './Registry';
import FAQ from './FAQ';

/**
 * Color:
 * 
 * d1caf4 - lavender
 */

const Wrapper = styled.div`
  width: 100%;

  @media (min-width: 1025px) {
    width: 80%;
  }

  @media (min-width: 1400px) {
    max-width: 1024px;
  }
  
`;

const TitleCard = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;

  @media (min-width: 1025px) {
    margin-top: 40px;
    padding: 10px;
  }

  @media (min-width: 1400px) {
    margin-bottom: 50px;
  }
  
`;

const TitleContent = styled.div`
  background-repeat: no-repeat;
  padding-top: 40px;
  padding-bottom: 10px;

  @media (min-width: 1025px) {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    min-height: 340px;
    padding-top: 100px;
  }

  @media (min-width: 1400px) {
    min-height: 440px;
    padding-top: 200px;
  }
`;

const TitleNames = styled.div`
  background: rgba(255, 255, 255, 0.3);
  font-family: 'Rouge Script', cursive;
  font-size: 6em;
  margin-bottom: 10px;
`;

const WeddingText = styled(TitleNames)`
  background: none;
  color: #D89400;
  font-size: 3.5em;
  margin-bottom: 70px;
`;

const DateText = styled.div`
  color: #D89400;
  font-size: 1.25em;
  margin-bottom: 35px;
`;

const ContentBody = styled.div`
  margin: 0px auto;
  padding: 10px;
  text-align: left;
`;

const Button = styled.div`
  background: #D89400;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  color: #fff;
  font-size: 1.25em;
  margin: 0px auto 20px auto;
  padding: 10px;
  width: 200px;

  &:hover {
    background: #d1caf4;
  }

  &:active {
    box-shadow: none;
  }

  @media (min-width: 1400px) {
    margin-bottom: 50px;
  }
`;



const Main = () => {
  return (
    <Wrapper>
      <TitleCard>
        <TitleContent>
          <TitleNames>Shirley and Wei</TitleNames>
          <WeddingText>Wedding Celebration!</WeddingText>
          <DateText>September 26th, 2021 <br /> 4:00pm</DateText>
        </TitleContent>
      </TitleCard>

      <a href='https://us02web.zoom.us/j/89188377480?pwd=N1Zmak04WWE3c2xwcGdHZGt6RWtGdz09'>
        <Button>Zoom Stream Link</Button>
      </a>

      <ContentBody>
        <Location />
        <Events />
        <Registry />
        <FAQ />
      </ContentBody>

    </Wrapper>
  );
}

export default Main;
